import { useDataSubmit, useDataValue, useDataChange } from 'Simple/Data'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'tags_picker',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'tags_picker',
    path: 'search_term',
    viewPath: props.viewPath,
  })

  let search_term = useDataValue({
    context: 'tags_picker',
    path: 'search_term',
    viewPath: props.viewPath,
  })

  return function onClick() {
    if (search_term) {
      submit({
        type: 'create_tag',
        value: {
          name: search_term,
        },
      })
      change('')
    }
  }
}
